import { Box } from 'grid-styled'
import { borders, fontWeight, width, themeGet } from 'styled-system'
import tinycolor from 'tinycolor2'

const darkenBG = (amount=3) => props => {
  const bgColor = themeGet(`colors.${props.bg}`)(props)
  const tcBGInstance = tinycolor(bgColor)
  const newBGColor = tcBGInstance.darken(amount).toString()
  const newBorderColor = tcBGInstance.darken(amount * 3).desaturate(amount * 7).toString()
  return `
    background-color: ${newBGColor};
    border-color: ${newBorderColor};
  `
}

const Button = Box.withComponent('button').extend`
  outline: none;
  color: white;
  :hover, :focus {
    color: white;
    ${darkenBG(3)};
  }
  :active {
    ${darkenBG(5)};
  }
  border: none;
  cursor: pointer;
  text-align: center;
  ${fontWeight}
  ${borders}
  ${width}
`

Button.defaultProps = {
  py: 3,
  px: 4,
  bg: 'primary.0',
  fontWeight: 'bold',
  color: 'white',
}

export default Button



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Button.js